export default __webpack_public_path__ + "static/media/b6.d87e6caa.png";